import {ACTION_CODE} from './_actionCode';
import {DealLossMotivesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_DEALLOSSMOTIVE';

export async function updateDealLossMotive(
    userData: Record<string, any>,
    dealLossMotiveId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateDealLossMotiveById - Start');

        const updateDealLossMotiveByIdResult =
            await DealLossMotivesService.updateDealLossMotive(userData, dealLossMotiveId, payloadUpdate);

        LoggerService.logInfo('Action - updateDealLossMotiveById - End - Success');

        return ResultModel.newSuccessResult(updateDealLossMotiveByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateDealLossMotiveById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
